import React from "react";
import "../App.css";
import {
  Row,
  Col,
  Layout,
  Divider,
  Carousel,
  Layout as AntdLayout,
} from "antd";
import "antd/dist/antd.css";
import styled from "@emotion/styled";
import Footer from "../components/Footer";
import HeaderEn from "../components/HeaderEn";
import oranges from "../assets/oranges.jpg";
import citrus from "../assets/citrus.jpg";
import fourfruit from "../assets/fourfruit.jpg";
import fruitandvegetables from "../assets/fruitandvegetables.jpg";
import {
  HistoryOutlined,
  TeamOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { IoEarth } from "react-icons/io5";

const Maintext = styled(AntdLayout.Content)({
  fontColor: "lightblack",
  textAlign: "center",
  fontSize: "20px",
  paddingLeft: "5%",
  paddingRight: "5%",
  paddingBottom: "3%",
  paddingTop: "4%",
});

const Headingtext = styled(AntdLayout.Content)({
  fontcolor: "lightblack",
  textAlign: "center",
  fontSize: "36px",
  paddingTop: "1%",
  fontWeight: "bold",
});
const CustomCarousel = styled(Carousel)({
  maxHeight: "700px",
  backgroundColor: "lightyellow",
  paddingTop: "1%",
  overflow: "hidden",
  "@media (min-width: 1600px)": {
    maxHeight: "1200px",
  },
  "@media (max-width: 1599px)": {
    maxHeight: "744px",
  },
  "@media (max-width: 992px)": {
    maxHeight: "744px",
  },
  "@media (max-width: 768px)": {
    maxHeight: "576x",
  },
  "@media (max-width: 576px)": {
    maxHeight: "432px",
  },
  "@media (max-width: 480px)": {
    maxHeight: "360px",
  },
  "@media (max-width: 320px)": {
    maxHeight: "240px",
  },
});
const CustomContent = styled(AntdLayout.Content)({
  backgroundColor: "lightyellow",
});

const Home_en: React.FC = (): JSX.Element => (
  <Layout>
    <HeaderEn/>
    <CustomContent>
      <br />
      <Headingtext>About Us</Headingtext>
      <CustomCarousel autoplay autoplaySpeed={4000}>
        <img src={fruitandvegetables} className="Fruitandveg" alt="logo"/>
        <img src={fourfruit} className="fourfruit" alt="logo" />
        <img src={citrus} className="Citrus" alt="logo" />
        <img src={oranges} className="Orangen" alt="logo" />
      </CustomCarousel>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Maintext>
            <HistoryOutlined
              style={{ fontSize: "50px", paddingBottom: "2%" }}
            />
            <br />
            Kika Holland was founded in September 2007 and belongs to the
            Milovan Milošević holding since June 2008. Milbana Bv is operating
            within the same holding since 2013. The reflection and synonym of
            our activities is related to the company Kika Holland, which has
            been the driving force behind the development of our entire holding
            all these years.
            <Divider />
            <TeamOutlined style={{ fontSize: "50px", paddingBottom: "2%" }} />
            <br />
            The founder and sole owner of Kika Holland is Milovan Milošević. In
            a talk for our website, he points out that the success of our
            company is based on self-discipline, prudent work, continuity,
            genuine respect for suppliers and customers, to whom we owe thanks
            for the objective success of Kika Holland Bv in this relatively
            short period of time.
            <Divider />
            <IoEarth style={{ fontSize: "77px", paddingBottom: "2%" }} />
            <br />
            The focus of our business is the import of green bananas from:
            Ecuador, Costa Rica, Mexico, Honduras, Nicaragua, and Colombia. The
            basic placement is in the Balkan market, where Kika Holland is
            certainly at the top in terms of annual volume placed. Besides
            bananas, we also emphasise the by now traditional import of citrus
            fruits from Argentina and the Republic of South Africa (both
            April-September). Many mixed products (fruit and vegetables) are
            also our speciality, which we have been dealing with from the very
            beginning, even before we entered into the import of green bananas.
            <Divider />
            <BarChartOutlined
              style={{ fontSize: "50px", paddingBottom: "2%" }}
            />
            <br />
            Strategic planning and monitoring of seasonal trends in the fruit
            and vegetable business distinguishes our company from others in the
            industry.
          </Maintext>
        </Col>
      </Row>
    </CustomContent>
    <Footer />
  </Layout>
);

export default Home_en;
